import { create } from "zustand";
import { StepId } from "@constants/navigation";

interface UseNavigateState {
    stepId: StepId;
    /**
     * @Warning This should be used only inside StepFlowGate.
     * Other steps don't need to know where to navigate and
     * StepFlowGate will handle the overall step flow.
     */
    navigateTo: (stepId: StepId) => void;
    navigateToSignInStep: () => void;
    navigateToPostStreamingStep: () => void;
}

export const useNavigateStore = create<UseNavigateState>((set) => ({
    stepId: StepId.INIT,
    navigateTo: (stepId) =>
        set(() => ({
            stepId,
        })),
    navigateToSignInStep: () =>
        set(() => ({
            stepId: StepId.SIGN_IN,
        })),
    navigateToPostStreamingStep: () =>
        set(() => ({
            stepId: StepId.POST_STREAMING,
        })),
}));
